<template>
  <div>
    <!-- 查询 -->
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item prop="projectId">
        <!-- <el-input v-model="searchInfo.projectId" size="small" placeholder="请输入项目名称" clearable></el-input> -->
        <el-select v-model="searchInfo.projectId" placeholder="请选择项目" filterable clearable>
          <el-option v-for="(item, index) in projectList" :label="item.projectName" :value="item.projectId"
            :key='index'>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="plantName">
        <el-input v-model="searchInfo.plantName" size="small" placeholder="请输入苗木名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="seedlingType">
        <el-select v-model="searchInfo.seedlingType" filterable placeholder="请选择苗木类别" clearable>
          <el-option v-for="item in typeList" :key="item.dicCode" :label="item.dicValue"
            :value="item.dicCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="treeAge">
        <el-input v-model="searchInfo.treeAge" placeholder="请输入树龄" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" start-placeholder="请选择养护日期"
          end-placeholder="请选择养护日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchData">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="map" id="map"></div>
  </div>
</template>

<script>
export default {
  name: 'SeedlingMap',
  data() {
    return {
      searchInfo: {
        plantName: '',
        projectId: '',
        isFamous: '0',
        seedlingType: '',
        treeAge: ''
      },
      projectList: [],
      typeList: [],
      date: [],
      isMapLoad: false,
      map: null,
      icon: require('@/assets/icon/seedling/icon_gushumingmu_zaixian.svg'),
      iconAlarm: require('@/assets/icon/seedling/icon_gushumingmu_gaojing.svg')
    }
  },
  computed: {
  },
  created() {
    this.loadMap().then(() => {
      this.isMapLoad = true
      this.getProtectList()
    })
    this.getTypeList()
  },
  mounted() {
  },
  destroyed() {
    // console.log('销毁地图')
    if (this.map) {
      this.map.off('click')
      this.map.destroy()
    }
  },
  methods: {
    // 查询苗木类别列表
    getTypeList() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'seedlingType' }).then(res => {
        this.typeList = res.seedlingType || []
      })
    },
    // 获取含有苗木的项目列表
    getProtectList() {
      this.$axios.get(this.$apis.seedling.selectYsProjectSumList).then((res) => {
        // console.log('res32', res)
        this.projectList = res || []
        if (this.projectList.length) {
          const projectInfo = this.projectList[0]
          const centerPosition = new AMap.LngLat(Number(projectInfo.longitude), Number(projectInfo.latitude))
          this.searchInfo.projectId = projectInfo.projectId
          this.getData(centerPosition)
        } else {
          this.$message.success('暂无项目，请先建立项目')
        }
      })
    },
    // 查询
    searchData() {
      this.getData([], true)
    },
    // 渲染地图
    loadMap() {
      return new Promise((resolve) => {
        resolve(AMap)
      })
    },
    drawMarks(list) {
      this.map.clearMap()
      list.forEach(item => {
        const statusInfo = this.getIconAndStatus(item)
        // 地图打点
        const marker = new AMap.Marker({
          position: new AMap.LngLat(+item.longitude, +item.latitude),
          icon: new AMap.Icon({
            // 图标的取图地址
            image: statusInfo.icon
          }),
          offset: new AMap.Pixel(-21, -43),
          label: {
            content: `<div class='map_tips'><div class="${statusInfo.status}"></div>&nbsp;${item.plantName}</div>`,
            offset: new AMap.Pixel(0, -10),
            direction: 'top'
          },
          extData: item.seedlingId
        })
        marker.on('click', (e) => {
          this.goDetail(e.target.getExtData())
        })
        this.map.add(marker)
      })
    },
    getIconAndStatus(detail) {
      return detail.runState && detail.runState === '1' ? {
        icon: this.iconAlarm,
        status: 'alarm'
      } : {
        icon: this.icon,
        status: 'normal'
      }
    },
    // 获取表格数据
    getData(centerPosition, isSearch) {
      this.$axios.get(this.$apis.seedling.selectYhSeedlingLocationList, {
        ...this.searchInfo,
        startDate: this.date ? (this.date[0] || '') : '',
        endDate: this.date ? (this.date[1] || '') : ''
      }).then((res) => {
        // console.log('res', res)
        const list = res || []
        if (list && list.length > 0) {
          const center = new AMap.LngLat(Number(list[0].longitude), Number(list[0].latitude))
          // 如果地图插件已加载，正常情况下，地图插件加载比数据拉去快速，但是这里价格判断，更严谨
          if (this.isMapLoad) {
            // 判断地图是否已绘制
            if (this.map) {
              this.map.setCenter(center)
            } else {
              this.map = new AMap.Map('map', { // 设置地图容器id
                zoom: 14,
                center: center
              })
            }
            this.drawMarks(list)
          } else {
            this.loadMap().then(() => {
              this.map = new AMap.Map('map', { // 设置地图容器id
                zoom: 14,
                center: center
              })
              this.drawMarks(list)
            })
          }
        } else {
          // 查询不到数据, 不移动地图
          if (!isSearch) {
            this.map = new AMap.Map('map', { // 设置地图容器id
              zoom: 14,
              center: centerPosition
            })
          }
          if (this.isMapLoad) {
            if (this.map) {
              this.map.clearMap()
            }
          }
          this.$message.success('暂未查询到数据信息')
        }
      })
    },
    goDetail(seedlingId) {
      this.$router.push({
        path: `/seedlingList/map/detail${seedlingId}`
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@mixin dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
}

.map {
  width: 100%;
  height: calc(100vh - 250px);

  ::v-deep .amap-marker-label {
    padding: 2px 6px;
    border: 0px;
    box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    .map_tips {
      display: flex;
      align-items: center;
      height: 22px;
      font-size: 12px;
      color: #333333;

      .alarm {
        @include dot();
        background: #FF341B;
      }

      .normal {
        @include dot();
        background: #3693FE;
      }
    }
  }
}
</style>
